package presentation.screens.appInfo

import utils.UiAction
import utils.UiState


data class AppInfoState(
    val mainText: String,
    val appVersion: String,
) : UiState

sealed interface AppInfoMVIAction : UiAction {
    data object onBackClicked : AppInfoMVIAction
}